// extracted by mini-css-extract-plugin
export default {"markdownContainer":"styles_markdownContainer__y1B3r"};